import React, { useMemo } from 'react';
import { components as selectComponents } from 'react-select';
import { createUseStyles } from 'react-jss';

import { Select, SelectProps } from '@app/form';
import { OptionProps } from 'react-select';
import { Theme } from '@app/theme';

import { Calendar } from '@app/api';
import { Chip } from '@app/core';
import { useTranslation } from 'react-i18next';

const useStyles = createUseStyles((theme: Theme) => ({
  optionContainer: {
    width: '100%',
  },
  optionLine: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    gap: theme.marginBase,
    flexWrap: 'wrap',
    alignItems: 'flex-end',
  },
  calendarName: {
    ...theme.fonts.label,
    color: null,
  },
  profileName: {
    ...theme.fonts.caption,
    color: theme.colors.inkTertiary,
  },
  secondaryText: {
    ...theme.fonts.caption,
    color: theme.colors.inkTertiary,
    textAlign: 'right',
  },
}));

const components = {
  Option: (props: OptionProps<any, boolean>) => {
    const classes = useStyles();
    const { t } = useTranslation();

    return (
      <selectComponents.Option {...props}>
        <div className={classes.optionContainer}>
          <div className={classes.optionLine}>
            <div className={classes.calendarName}>{props.children}</div>
            <div className={classes.secondaryText}>{props.data.provider}</div>
          </div>
          <div className={classes.optionLine}>
            <div className={classes.profileName}>{props.data.profileName}</div>
            {props.data.disconnected && (
              <Chip color="red">
                {t('editSession.settings.moderator.disconnected.chip')}
              </Chip>
            )}
          </div>
        </div>
      </selectComponents.Option>
    );
  },
};

export const CalendarSelect = ({
  calendars,
  ...props
}: SelectProps & { calendars: Calendar[] }) => {
  const options = useMemo(
    () =>
      calendars.map((calendar) => ({
        label: calendar.name,
        value: calendar.id,
        profileName: calendar.profileName,
        provider: calendar.provider,
        disconnected: calendar.isDisconnected,
      })),
    [calendars],
  );

  return (
    <React.Fragment>
      <Select components={components as any} {...props} options={options} />
    </React.Fragment>
  );
};
